export const PreDiscountPriceInterval = 100;

export const PreDiscountPriceExampleImage = Object.freeze({
  ForPOD:
    'https://image1.marpple.co/files/u_2232571/2023/11/original/ea25e1425e3a5cd6e3da12039d7c2c88dace4a242.png?q=80&f=webp',
  ForNonPOD:
    'https://image1.marpple.co/files/u_2232571/2023/11/original/4f1b766ff3077062404d953c7348acef8e50c24d1.png?q=80&f=webp',
});
